import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Separator,
} from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";

import { useTestAuthApi } from "@/lib/queries/use-test-auth-api";

export default function AdminDashboard() {
  const { user, signOut } = useAuth();
  const testApiMutation = useTestAuthApi();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-muted p-6">
      <div className="container mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold">Admin</h1>
          <Button variant="outline" onClick={() => signOut()}>
            Sign out
          </Button>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <Card>
            <CardHeader>
              <CardTitle>Profile</CardTitle>
              <CardDescription>Authenticated user details</CardDescription>
            </CardHeader>
            <CardContent className="space-y-2 text-sm">
              <div>
                <span className="text-muted-foreground">Name:</span> {user?.name || "—"}
              </div>
              <div>
                <span className="text-muted-foreground">Email:</span> {user?.email || "—"}
              </div>
              <div>
                <span className="text-muted-foreground">Role:</span> {user?.role || "—"}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Authenticated API</CardTitle>
              <CardDescription>Quick session check</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex gap-3">
                <Button
                  onClick={() => testApiMutation.mutate()}
                  disabled={testApiMutation.isPending}
                >
                  {testApiMutation.isPending ? "Testing..." : "Run test"}
                </Button>
              </div>
              <Separator />
              {testApiMutation.data && (
                <pre className="text-xs overflow-auto rounded-md bg-muted p-4">
                  {JSON.stringify(testApiMutation.data, null, 2)}
                </pre>
              )}
              {testApiMutation.error && (
                <div className="rounded-md bg-red-50 text-red-700 p-4 text-sm">
                  {testApiMutation.error.message}
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
